import React, { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { CardContainer } from 'components/shared/CardContainer/CardContainer';
import { Box } from '@mui/material';
import { IS_DEVELOPMENT } from 'constants/common';
import { BaseTable } from 'modules/proposals';
import { Proposal } from '@trnsact/trnsact-shared-types';
import { useDealBuilderContext } from '../../context/DealBuilderContext';
import { getContactId } from '../../lib';

export const QuoteHistory = () => {
  const account = useSelector((state: any) => state.account);
  const { historyEntities, contactsData, setActiveEntity } = useDealBuilderContext();

  const tableData = useMemo(() => {
    const contactById = new Map(contactsData.allContacts.map(c => [getContactId(c), c]));

    return historyEntities.map(entity => {
      const firstContact = (entity.proposalContacts ?? [])[0];
      const contact = firstContact
        ? contactById.get(firstContact.ownerPgId ?? firstContact.accountContactId ?? '')
        : undefined;
      const [firstName = '', ...rest] = contact?.fullName?.split(' ') ?? [];
      const lastName = rest.join(' ');

      return {
        proposalId: entity.proposalId,
        createdDateTime: entity.proposal.createdDateTime,
        businessName: entity.proposal.businessName,
        firstName,
        lastName,
        saleType: entity.proposal.saleType,
        amountRequested: entity.proposal.amountRequested,
        status: entity.proposal.status,
        salesPersonName: entity.proposal.salesPersonName,
        vendorOpportunityId: entity.proposal.vendorOpportunityId,
      };
    }) as unknown as Proposal[];
  }, [historyEntities, contactsData.allContacts]);

  const handleGoToProposalDetail = (proposal: Proposal) => {
    window.open(
      `https://app${IS_DEVELOPMENT ? '.dev' : ''}.trnsact.com/ps/?vendorGUID=${account.dynamicsAccountId}&proposalId=${proposal.proposalId}&viewOnly=true`,
      '_blank'
    );
  };

  const handleGoToProposal = (proposal: Proposal) => {
    window.open(`/proposalDetail/${proposal.proposalId}?from=/vo/${proposal.vendorOpportunityId}`, '_blank');
  };

  const handleEditProposal = (proposal: Proposal) => {
    setActiveEntity(proposal.proposalId as string);
  };

  return (
    <Box>
      <CardContainer title="Quote History">
        <BaseTable
          onEditProposal={handleEditProposal}
          onGoToProposal={handleGoToProposal}
          onGoToProposalDetail={handleGoToProposalDetail}
          tableData={tableData}
        />
      </CardContainer>
    </Box>
  );
};
